module.exports = __webpack_public_path__ + "img/V100.91b58947.jpg";